<template>
    <div class="main main--hasHeader main--hasFooter">
        <div class="customContainer">
            <div class="information-detail">
                <div class="information-detail__inner border-bottom mb-3">
                  <p class="information-detail__date" v-if="set_date_check(information.set_date_date_val)">{{ information.set_date_date_val }}</p>
                  <h2 class="information-detail__headline">{{ information.subject }}</h2>
                  <p class="information-detail__image" v-if="information.header_image_path != 'null'">
                    <img :src="information.header_image_path">
                  </p>
                  <p class="information-detail__description" style="white-space: pre-line;" v-if="set_date_check(information.body)" v-html="url_search_attach_link(information.body)"></p>
                </div>
                <div class="information-detail__inner" v-if="typeof information === 'object'">
                  <div class="d-block mb-2" v-for="(asset, index) in information.assets" :key="asset">
                    <a :href="asset.path" target="_blank" v-if="asset.label">{{ word_chg(asset.label) }}</a>
                    <a :href="asset.path" target="_blank" v-else>{{ word_chg('ファイル') }}{{ (index + 1) }}</a>
                  </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
// import BsTextArea from '../../atoms/BsTextArea.vue'
// import BsCheckBox from '../../atoms/BsCheckBox.vue'
// import '../../assets/bootstrap/css/sc.css';
import config from '../../../const'
import axios from 'axios'
import Common from '../../../common/common'

export default {
  name: 'InformationDetailView',
  data: function () {
      return {
        // 'information': {},
        'targetid': this.$route.params.id,
        source: [],
      }
  },
  components: {
    //   BsButton,
      // BsTextArea,
      // BsCheckBox,
  },
  methods: {
    async loadInformation(){
        const params = {};
        params['stat'] = [1];
        params['id'] = this.targetid;
        // params['financial_status'] = 10;
        const params_ = Common.createParams(params);
        axios.post(
            config.BASE_API_URL + '/information/lists',
            params_,
            {
            headers: this.axiosHeader
            }
        )
        .then(
            (response) => {
              this.source = response.data.body;
              console.log('response', response);
            }
        )
        .catch((err) => {
          this.source = [];
          console.log('error', err);
            // this.search_sales = [];
        })
        .finally(() => {
            // console.log('finally files', this.files);
            // this.loadingFinish = true;
            this.$forceUpdate();
        });

      },
  },
  computed: {
    ...mapState({
      btnLabel() {
          if(this.add){
              return '新規登録';
          }
          else{
              return '更新';
          }
      },
    // tag_group: state => state.apidata.tag_group
      // tags_list: state => state.tags.lists
    }),
    information: function(){
      console.log('this.soc', this.source);
      if(
        typeof this.source === 'object'
        && Object.keys(this.source).length > 0
      ){
        return this.source[0];
      }
      return [];
    },

    url_search_attach_link: function(){
      // const pattern = /https?:\/\/[-_.!~*'()a-zA-Z0-9;/?:@&=+$,%#]+/ig
      return function(body){
        return body.replace(/(https?:\/\/[^\s]*)/g, "<a href='$1' target='_blank'>$1</a>");
      }
    },
    set_date_check: function(){
            return function(value){
                if(
                    value != null 
                    && value != 'null' 
                    && value != '0000-00-00' 
                    && value != '' 
                    && value != false
                    && value != 'false' 
                    && value != undefined
                    && value != 'undefined'
                ){
                    return true;
                }else{
                    return false;
                }
            }
    },
    axiosHeader: function(){
          return {[config.BASE_API_HEADER_KEY]: this.$store.state.auth.token};
      },
  },
  async created () {
    if(Number.isNaN(this.targetid)){
      this.$router.push({ path: '/' })
    }
    await this.loadInformation();

    // if(this.targetid == 'add'){
    //   console.log('add');
    //   // console.log('this.article', this.article);
    //   this.information = {
    //     'subject': '',
    //     'body': ''
    //   };
    //   console.log('this.type', this.type);
    // }else{
    //   const ret = !Number.isNaN(this.targetid)
    //     ? {...this.$store.getters.getBasicById(this.targetid, 'information')}
    //     : {};
    //   if(Object.keys(ret).length > 0){
    //     this.add = false;
    //   }
    //   this.information = ret;
    // }
  },
  mounted: function(){
      // console.log(this.$route.path);
      // console.log('strage', this.$store.state.article);
      // console.log('this', ...this.$store.getters.getArticleById(1));
      this.fromParentTitle = 'お知らせ詳細';
      this.alertMessage = this.btnLabel + 'できます';
      // console.log('tags_list', this.tags_list);
  },

  // computed: {
  //   article () {
  //     // const id = parseInt(this.$route.params.id);
  //     // console.log(id, 'idid');
  //     console.log('ret', ret);
  //     return ret;
  //   }
  // },
  props: {
    // article: {
    //   type: Object,
    //   required: true,
    //   default: () => {}
    // },
    // onupdate: {
    //   type: Function,
    //   required: true
    // },
  }

}
</script>
